function byteLength(string) {
  string = String(string);
  let l = string.length;
  let byteLength = 0;
  for (let i = 0; i < l; i += 1) {
    let char = string.charCodeAt(i);
    byteLength +=
      char < 1 << 7 ? 1 : 1 << 11 ? 2 : 1 << 16 ? 3 : 1 << 31 ? 4 : NaN;
  }
  return byteLength;
}
function bufToString2(buf) {
  let view = new DataView(buf);
  let str = "";
  let offset = 0;
  for (let i = 0, l = view.byteLength; i < l; i += 1) {
    if (view.getUint8(i) > 0) {
      let ch = String.fromCharCode(view.getUint8(i));
      str += ch;
    }
  }
  return str;
}
function bufToString(buf) {
  let view = new DataView(buf);
  let str = "";
  let offset = 0;
  for (let i = 0, l = view.byteLength; i < l; i += 1) {
    let ch = String.fromCharCode(view.getUint8(i));
    str += ch;
    if (ch === "}") {
      offset = i + 1;
      break;
    }
  }
  return { data: JSON.parse(str), offset: offset };
}
function toArrayBuf(str, type = "Uint8", size = 0) {
  let buf = new ArrayBuffer(size || byteLength(str));
  let view = new DataView(buf);
  for (let i = 0, l = str.length; i < l; i += 1) {
    view[`set${type}`](i, str.charCodeAt(i));
  }
  return buf;
}
function toBytesInt32(num) {
  const arr = new Uint8Array([
    (num & 0xff000000) >> 24,
    (num & 0x00ff0000) >> 16,
    (num & 0x0000ff00) >> 8,
    num & 0x000000ff
  ]);
  return arr;
}

export { bufToString2, bufToString, toArrayBuf, toBytesInt32 };
